import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';
import { CreateChecklistDto, IAgency, IChecklist, UpdateChecklistDto } from 'admiral-core';

export class ChecklistApi {
  static getChecklists(
    agency: IAgency,
    damageId?: string,
    taskId?: string,
  ): Promise<AxiosResponse<IChecklist[]>> {
    return AdmiralApi.apiCall<IChecklist[]>({
      method: 'POST',
      url: `${BASE_URL}/checklist/list`,
      data: { agency, id: damageId, taskId },
    });
  }

  static getTemplates(agency: IAgency): Promise<AxiosResponse<IChecklist[]>> {
    return AdmiralApi.apiCall<IChecklist[]>({
      method: 'POST',
      url: `${BASE_URL}/checklist/templates`,
      data: { agency },
    });
  }

  static create(dto: CreateChecklistDto): Promise<AxiosResponse<IChecklist>> {
    return AdmiralApi.apiCall<IChecklist>({
      method: 'POST',
      url: `${BASE_URL}/checklist/create`,
      data: dto,
    });
  }

  static update(id: string, dto: UpdateChecklistDto): Promise<AxiosResponse<IChecklist>> {
    return AdmiralApi.apiCall<IChecklist>({
      method: 'PATCH',
      url: `${BASE_URL}/checklist/${id}`,
      data: dto,
    });
  }

  static delete(id: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'DELETE',
      url: `${BASE_URL}/checklist/${id}`,
    });
  }
}
